export default __webpack_public_path__ + "static/media/Common.749de494.png";